export default __webpack_public_path__ + "static/media/back-arrow.35338af8.svg";